// Feature: docs/features/deterministic-rules-management.md
import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  IconButton,
  HStack,
  Tooltip
} from '@chakra-ui/react';
import { DeleteIcon } from '@chakra-ui/icons';

const RulesTable = ({ rules, onStop }) => {
  const getPhaseColor = (phase) => {
    switch (phase) {
      case 'all-pre': return 'purple';
      case 'payer': return 'blue';
      case 'carrier': return 'cyan';
      case 'all-post': return 'green';
      default: return 'gray';
    }
  };

  return (
    <Table variant="simple" size="sm">
      <Thead>
        <Tr>
          <Th>Status</Th>
          <Th>Phase</Th>
          <Th>Target</Th>
          <Th>Action</Th>
          <Th>Start Date</Th>
          <Th textAlign="right">Manage</Th>
        </Tr>
      </Thead>
      <Tbody>
        {rules.map((rule) => (
          <Tr key={rule.id}>
            <Td>
              <Badge colorScheme="green">Active</Badge>
            </Td>
            <Td>
              <Badge colorScheme={getPhaseColor(rule.rule_type)}>
                {rule.rule_type}
              </Badge>
            </Td>
            <Td fontWeight="medium">
              {rule.target_name || 'ALL'}
            </Td>
            <Td fontFamily="monospace" fontSize="sm">
              {rule.action}
            </Td>
            <Td>
              {new Date(rule.effective_start_date).toLocaleDateString()}
            </Td>
            <Td textAlign="right">
              <HStack spacing={2} justify="flex-end">
                <Tooltip label="Stop Rule">
                  <IconButton
                    icon={<DeleteIcon />}
                    size="sm"
                    colorScheme="red"
                    variant="ghost"
                    onClick={() => onStop(rule.id)}
                    aria-label="Stop rule"
                  />
                </Tooltip>
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default RulesTable;
